var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 40C56 48.8365 48.8366 56 40 56C31.1634 56 24 48.8365 24 40C24 31.1634 31.1634 24 40 24C48.8366 24 56 31.1634 56 40Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 19C37.2386 19 35 16.7614 35 14V5.99999C35 3.23857 37.2386 0.999994 40 0.999994C42.7614 0.999994 45 3.23857 45 5.99999V14C45 16.7614 42.7614 19 40 19Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 61C42.7614 61 45 63.2386 45 66V74C45 76.7614 42.7614 79 40 79C37.2386 79 35 76.7614 35 74V66C35 63.2386 37.2386 61 40 61Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8493 25.1508C52.8966 23.1981 52.8966 20.0323 54.8493 18.0797L60.5061 12.4228C62.4587 10.4702 65.6246 10.4702 67.5772 12.4228C69.5298 14.3755 69.5298 17.5413 67.5772 19.4939L61.9203 25.1508C59.9677 27.1034 56.8019 27.1034 54.8493 25.1508Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1508 54.8492C27.1034 56.8019 27.1034 59.9677 25.1508 61.9203L19.4939 67.5772C17.5413 69.5298 14.3755 69.5298 12.4228 67.5772C10.4702 65.6245 10.4702 62.4587 12.4228 60.5061L18.0797 54.8492C20.0323 52.8966 23.1981 52.8966 25.1508 54.8492Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61 40C61 37.2386 63.2386 35 66 35H74C76.7614 35 79 37.2386 79 40C79 42.7614 76.7614 45 74 45H66C63.2386 45 61 42.7614 61 40Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 40C19 42.7614 16.7614 45 14 45L6 45C3.23858 45 1 42.7614 1 40C1 37.2386 3.23858 35 6 35L14 35C16.7614 35 19 37.2386 19 40Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8493 54.8492C56.8019 52.8966 59.9677 52.8966 61.9203 54.8492L67.5772 60.5061C69.5298 62.4587 69.5298 65.6245 67.5772 67.5772C65.6246 69.5298 62.4587 69.5298 60.5061 67.5772L54.8493 61.9203C52.8966 59.9677 52.8966 56.8019 54.8493 54.8492Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1508 25.1507C23.1981 27.1034 20.0323 27.1034 18.0797 25.1507L12.4228 19.4939C10.4702 17.5413 10.4702 14.3754 12.4228 12.4228C14.3755 10.4702 17.5413 10.4702 19.4939 12.4228L25.1508 18.0797C27.1034 20.0323 27.1034 23.1981 25.1508 25.1507Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToday);
export default __webpack_public_path__ + "static/media/today.2c7a871e44db4f720e92e9ec1b44f25b.svg";
export { ForwardRef as ReactComponent };